const initProgressBar = () => {
	const progressBar = document.querySelector('.progress-bar')

	if (!progressBar) {
		return
	}

	const readingProgress = document.querySelector('.reading-progress')
	let postHeader = document.querySelector('.post-header')
	const header = document.querySelector('.header')
	const headerHeight = header.clientHeight

	const updateProgress = () => {
		const postHeaderHeight = postHeader.clientHeight
		const postContentHeight =
			document.querySelector('.post-content').clientHeight
		const position = window.scrollY
		const progress = (position / (postHeaderHeight + postContentHeight)) * 100

		readingProgress.setAttribute('value', progress)

		requestAnimationFrame(updateProgress)
	}

	if (readingProgress) updateProgress()

	const animateProgressBar = () => {
		const postHeaderHeight = postHeader.clientHeight
		const postContentHeight =
			document.querySelector('.post-content').clientHeight
		if (
			window.scrollY > postHeaderHeight + headerHeight &&
			window.scrollY < postHeaderHeight + headerHeight + postContentHeight
		) {
			progressBar.classList.add('show')
		} else {
			progressBar.classList.remove('show')
		}
	}

	window.addEventListener('scroll', animateProgressBar)
}

export {initProgressBar}
